import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const checkIsExitsReqArriveLateSlice = createSlice({
  name: "checkIsExitsReqArriveLate",
  initialState,
  reducers: {
    checkIsExitsReqArriveLateStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    checkIsExitsReqArriveLateSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    checkIsExitsReqArriveLateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  checkIsExitsReqArriveLateStart,
  checkIsExitsReqArriveLateSuccess,
  checkIsExitsReqArriveLateFailed,
} = checkIsExitsReqArriveLateSlice.actions;

export default checkIsExitsReqArriveLateSlice.reducer;
